/** Compatibility export; the business domain owns this implementation. */
export { ListingLimitationsServiceOld } from '@domains/upload/shared';
